"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var List = function List(_ref) {
  var render = _ref.render;
  return render();
};

List.propTypes = {
  open: _propTypes["default"].func,
  close: _propTypes["default"].func,
  select: _propTypes["default"].func,
  error: _propTypes["default"].bool,
  list: _propTypes["default"].array,
  listRef: _propTypes["default"].object,
  theme: _propTypes["default"].object,
  style: _propTypes["default"].object,
  focus: _propTypes["default"].func,
  render: _propTypes["default"].func,
  virtualListRender: _propTypes["default"].func,
  virtualized: _propTypes["default"].bool
};
var _default = List;
exports["default"] = _default;